import { Badge, Paper as MantinePaper } from "@mantine/core";
import { ReactNode } from "react";

type PaperVariant = "primary" | "secondary" | "warning" | "success" | "danger" | "dark";

const variantStyles: Record<PaperVariant, { background: string; borderColor: string }> = {
    danger: {
        background: "rgb(250 82 82 / 6%)",
        borderColor: "rgb(250 82 82 / 20%)",
    },
    dark: {
        background: "var(--app-surface-strong)",
        borderColor: "var(--app-border)",
    },
    primary: {
        background: "var(--app-surface)",
        borderColor: "var(--app-border)",
    },
    secondary: {
        background: "linear-gradient(180deg, rgb(23 145 184 / 7%), rgb(23 145 184 / 2%))",
        borderColor: "rgb(23 145 184 / 24%)",
    },
    success: {
        background: "rgb(64 192 87 / 6%)",
        borderColor: "rgb(64 192 87 / 20%)",
    },
    warning: {
        background: "rgb(250 176 5 / 7%)",
        borderColor: "rgb(250 176 5 / 22%)",
    },
};

export function Paper(props: {
    children: ReactNode;
    variant?: PaperVariant | null;
    floatingHeader?: string | undefined | null;
}) {
    const type = props.variant ?? "primary";

    return (
        <MantinePaper
            mb="md"
            p="md"
            pb="lg"
            pos="relative"
            pt={props.floatingHeader ? 42 : "md"}
            radius="sm"
            shadow="sm"
            style={{
                background: variantStyles[type].background,
                border: `1px solid ${variantStyles[type].borderColor}`,
                color: "var(--mantine-color-text)",
            }}>
            {props.floatingHeader ? (
                <Badge
                    color="gray"
                    left={12}
                    pos="absolute"
                    radius="xs"
                    style={{ letterSpacing: "0.01em" }}
                    top={12}
                    variant="default">
                    {props.floatingHeader}
                </Badge>
            ) : null}
            {props.children}
        </MantinePaper>
    );
}
